import { render, staticRenderFns } from "./CovidSafety.vue?vue&type=template&id=5de366ea&"
import script from "./CovidSafety.vue?vue&type=script&lang=js&"
export * from "./CovidSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports